import { render, staticRenderFns } from "./Podiatry.vue?vue&type=template&id=0e1d5ff0&"
import script from "./Podiatry.vue?vue&type=script&lang=js&"
export * from "./Podiatry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports